import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import SearchOffRoundedIcon from '@mui/icons-material/SearchOffRounded';

// Page shown for any unknown route inside the admin.
const NotFound = () => {
  const { t }: { t: any } = useTranslation();
  const navigate = useNavigate();
  return (
    <Box sx={{ minHeight: '60vh', display: 'grid', placeItems: 'center', px: 2, textAlign: 'center' }}>
      <Box sx={{ maxWidth: 420 }}>
        <Box
          sx={{
            width: 64,
            height: 64,
            mx: 'auto',
            mb: 3,
            borderRadius: '50%',
            display: 'grid',
            placeItems: 'center',
            backgroundColor: 'background.paper',
            color: 'text.secondary',
            '& .MuiSvgIcon-root': { fontSize: 30 }
          }}
        >
          <SearchOffRoundedIcon />
        </Box>
        <Typography variant="h3" component="h1" sx={{ mb: 1 }}>
          {t('Page not found')}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {t('The link may be wrong or the page may have moved.')}
        </Typography>
        <Button variant="contained" color="primary" startIcon={<ArrowBackRoundedIcon />} onClick={() => navigate('/')}>
          {t('Back to dashboard')}
        </Button>
      </Box>
    </Box>
  );
};

export default NotFound;
